export default "__VITE_ASSET__178984d3__"